import { configureStore } from '@reduxjs/toolkit'
import global from "./global/reducers";
import auth from "./auth/reducers";

export const store = configureStore({ reducer: { global, auth } });